function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#27864c",
  d: "M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16 0-4.243-1.686-8.313-4.686-11.314s-7.070-4.686-11.314-4.686zM16 28c-6.627 0-12-5.373-12-12s5.373-12 12-12c6.627 0 12 5.373 12 12 0 3.183-1.264 6.235-3.515 8.485s-5.303 3.515-8.485 3.515zM22.844 10.24l0.892 0.889c0.169 0.157 0.264 0.372 0.264 0.595s-0.095 0.438-0.264 0.595l-10.029 9.426c-0.162 0.162-0.388 0.254-0.625 0.254s-0.463-0.092-0.625-0.254l-4.194-3.975c-0.169-0.157-0.264-0.372-0.264-0.595s0.095-0.438 0.264-0.595l0.946-0.889c0.162-0.162 0.388-0.254 0.625-0.254s0.463 0.092 0.625 0.254l2.677 2.499 8.459-7.95c0.347-0.32 0.902-0.32 1.249 0z"
});

function SvgValid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValid);
export default __webpack_public_path__ + "static/media/valid.6c930dd9.svg";
export { ForwardRef as ReactComponent };